export type ServiceFaq = { q: string; a: string };

export type ServicePageContent = {
  slug: string;
  badge: string;
  h1: string;
  intro: string;
  sections: { title: string; body: string[] }[];
  highlights: string[];
  faq: ServiceFaq[];
};

export const SERVICE_PAGES: Record<string, ServicePageContent> = {
  services: {
    slug: 'services',
    badge: 'Lbenna Prod Â· Tunis & Djerba',
    h1: 'Nos Services Photo, Vidéo & Ã‰vénementiel',
    intro:
      'Depuis 1988, Lbenna Prod accompagne particuliers et entreprises en Tunisie avec une offre complète : photographie de mariage, captation vidéo, location photobooth, production corporate et shooting studio. Basés Ã  Tunis et actifs Ã  Djerba, nous combinons savoir-faire artisanal et matériel professionnel (4K, drone, éclairage studio) pour livrer des images qui racontent votre histoire.',
    sections: [
      {
        title: 'Une maison de production audiovisuelle reconnue en Tunisie',
        body: [
          'Lbenna Prod n\'est pas une simple agence de location de matériel : c\'est un studio photo-vidéo événementiel fondé en 1988, avec une équipe stable de photographes, vidéastes, monteurs et techniciens lumière. Nous intervenons sur l\'ensemble du territoire tunisien, avec une forte présence Ã  Tunis pour les événements corporate et Ã  Djerba pour les mariages destination.',
          'Notre approche repose sur l\'écoute du client, la préparation en amont (repérage, moodboard, planning) et une post-production exigeante. Chaque prestation â€” du clip musical au reportage de mariage â€” est pensée pour être intemporelle, lumineuse et fidèle Ã  l\'émotion du moment.',
          'Que vous organisiez un gala d\'entreprise Ã  La Marsa, un mariage Ã  Djerba ou un shooting packshot en studio, vous bénéficiez du même niveau d\'exigence et d\'un interlocuteur unique du devis Ã  la livraison.',
        ],
      },
      {
        title: 'Photographie & vidéo de mariage',
        body: [
          'Le mariage reste au cÅ“ur de notre identité. Nous proposons des formules photo, vidéo ou duo photo-vidéo, avec une couverture complète : préparatifs, cérémonie, soirée, et options drone ou same-day edit. Nos photographes maîtrisent la lumière naturelle comme les flashes en reception, pour des images nettes et chaleureuses.',
          'Côté vidéo, nos films mêlent captation documentaire et montage cinématographique : plans stabilisés, interviews des proches, musique originale ou licence, livraison en fichier HD et teaser pour les réseaux sociaux. Nous connaissons les lieux emblématiques de Tunis et les hôtels de Djerba, ce qui accélère la logistique le jour J.',
        ],
      },
      {
        title: 'Photobooth, corporate & studio',
        body: [
          'Notre borne photobooth interactive est prisée pour les mariages et soirées d\'entreprise : photos instantanées, fond personnalisé aux couleurs de votre marque, animateur sur place et galerie en ligne. C\'est l\'animation idéale pour créer des souvenirs partagés et du contenu viral.',
          'En production corporate, nous réalisons films institutionnels, captation de conférences, interviews dirigeants et contenus réseaux sociaux. En studio, nous produisons portraits professionnels, lookbooks mode et packshots produits pour e-commerce â€” toujours avec retouche incluse.',
        ],
      },
    ],
    highlights: [
      'Devis gratuit sous 24 h',
      'Intervention Tunis, Djerba & toute la Tunisie',
      'Studio fondé en 1988',
      'Matériel 4K, drone & studio équipé',
    ],
    faq: [
      {
        q: 'Quels services propose Lbenna Prod ?',
        a: 'Mariage photo/vidéo, photobooth, production corporate, clips, shooting studio et packshot produit, Ã  Tunis et Djerba.',
      },
      {
        q: 'Intervenez-vous en dehors de Tunis ?',
        a: 'Oui, nous couvrons toute la Tunisie. Djerba est l\'une de nos zones les plus demandées pour les mariages destination.',
      },
      {
        q: 'Comment obtenir un devis ?',
        a: 'Contactez-nous via le formulaire en ligne ou par téléphone. Nous répondons sous 24 h avec une proposition détaillée.',
      },
      {
        q: 'Proposez-vous photo et vidéo le même jour ?',
        a: 'Oui, nos formules duo photo-vidéo sont conçues pour une coordination fluide entre les deux équipes.',
      },
    ],
  },

  mariage: {
    slug: 'mariage',
    badge: 'Mariage Â· Photo & Film',
    h1: 'Photographe et Vidéaste Mariage Ã  Tunis et Djerba',
    intro:
      'Confiez votre mariage Ã  Lbenna Prod : photographe et vidéaste professionnels depuis 1988. Nous capturons chaque instant â€” des préparatifs Ã  la soirée â€” avec sensibilité, discrétion et une esthétique intemporelle. Disponibles Ã  Tunis, Djerba et partout en Tunisie.',
    sections: [
      {
        title: 'Un regard artistique sur votre jour J',
        body: [
          'Votre mariage est unique. Notre mission est de le raconter avec authenticité : les rires, les larmes de joie, les détails décoratifs, les regards complices. Nos photographes alternent plans posés et reportage spontané pour un album complet, livré retouché et prêt Ã  partager.',
          'Nous travaillons en binôme ou en équipe élargie selon la taille de votre événement. Avant le grand jour, nous échangeons sur vos attentes, vos invités clés et le déroulé horaire pour anticiper chaque séquence importante.',
          'Ã€ Djerba comme Ã  Tunis, nous connaissons les contraintes des lieux de réception (lumière, accès drone, timing coucher de soleil) et adaptons notre dispositif en conséquence.',
        ],
      },
      {
        title: 'Films de mariage cinématographiques',
        body: [
          'Nos vidéastes produisent des films courts (teaser) et longs format, avec captation multi-caméras, micro-cravate pour les discours et musique adaptée. Le montage respecte le rythme de votre journée : émotion, dynamisme et élégance.',
          'Options disponibles : drone aérien, same-day edit projeté en soirée, sous-titres pour la famille Ã  l\'étranger, livraison sur clé USB personnalisée et galerie en ligne privée.',
        ],
      },
      {
        title: 'Formules & accompagnement',
        body: [
          'Nous proposons des packs photo seul, vidéo seul ou duo, avec possibilité d\'ajouter photobooth, album premium ou séance engagement avant le mariage. Chaque devis est transparent : heures incluses, nombre de retouches, délais de livraison.',
          'Notre équipe reste joignable jusqu\'au jour J pour ajuster le planning. Le jour de la cérémonie, un chef de projet coordonne photo et vidéo pour que vous n\'ayez qu\'Ã  profiter.',
        ],
      },
    ],
    highlights: [
      'Reportage mariage Tunis & Djerba',
      'Album photo retouché',
      'Film cinématographique 4K',
      'Options drone & photobooth',
    ],
    faq: [
      {
        q: 'Combien de temps Ã  l\'avance réserver un photographe mariage ?',
        a: 'Nous conseillons de réserver 6 Ã  12 mois Ã  l\'avance, surtout pour la haute saison Ã  Djerba et les week-ends estivaux Ã  Tunis.',
      },
      {
        q: 'Photographiez-vous les mariages Ã  Djerba ?',
        a: 'Oui, Djerba fait partie de nos zones principales. Nous connaissons les hôtels et venues de l\'île.',
      },
      {
        q: 'Livrez-vous les photos rapidement ?',
        a: 'Un aperçu est partagé sous 48â€“72 h. L\'album complet est livré selon la formule choisie, généralement sous 4 Ã  6 semaines.',
      },
      {
        q: 'Peut-on combiner photo, vidéo et photobooth ?',
        a: 'Absolument. Nous proposons des packages combinés avec un seul interlocuteur Lbenna Prod.',
      },
    ],
  },

  photobooth: {
    slug: 'photobooth',
    badge: 'Animation Â· Tirage instantané',
    h1: 'Location Photobooth Mariage en Tunisie',
    intro:
      'Animez votre mariage ou événement corporate avec le photobooth Lbenna Prod : photos instantanées premium, fond personnalisé, accessoires fun et animateur professionnel. Installation Ã  Tunis, Djerba et partout en Tunisie.',
    sections: [
      {
        title: 'Une animation clé en main',
        body: [
          'Le photobooth est devenu incontournable pour créer des souvenirs tangibles. Nos bornes haute résolution impriment en quelques secondes des photos format polaroid ou carte postale, personnalisées avec vos prénoms, date et logo.',
          'Un technicien Lbenna Prod installe le matériel, règle la lumière, propose des accessoires (chapeaux, pancartes, lunettes) et encourage les invités Ã  participer. Résultat : une ambiance dynamique et des photos que vos proches emportent chez eux.',
          'Nous proposons aussi une galerie en ligne privée pour télécharger les photos numériques et les partager sur Instagram ou Facebook.',
        ],
      },
      {
        title: 'Mariage, entreprise & lancement produit',
        body: [
          'En mariage, le photobooth fonctionne en continu pendant la réception : les invités repartent avec un souvenir, vous recevez un album consolidé. En corporate, nous adaptons le branding (fond aux couleurs de l\'entreprise, template avec slogan) pour vos séminaires, inaugurations ou salons.',
          'La location inclut transport, montage, démontage et assistance technique. Nous pouvons couvrir une soirée ou plusieurs jours pour les festivals et événements touristiques Ã  Djerba.',
        ],
      },
      {
        title: 'Qualité d\'image professionnelle',
        body: [
          'Contrairement aux solutions low-cost, notre photobooth utilise un éclairage studio doux, un appareil reflex ou hybride plein format et une finition labo. Les photos sont nettes, bien exposées et flatteuses â€” même en soirée.',
          'Options : GIF animés, boomerang vidéo, livre d\'or photo numérique, green screen et envoi des photos par QR code.',
        ],
      },
    ],
    highlights: [
      'Tirages instantanés HD',
      'Animateur & accessoires inclus',
      'Branding personnalisé',
      'Galerie en ligne',
    ],
    faq: [
      {
        q: 'Quelle surface faut-il pour installer le photobooth ?',
        a: 'Environ 3 Ã— 3 mètres suffisent pour la borne, l\'éclairage et un petit espace invités.',
      },
      {
        q: 'Le photobooth est-il adapté aux mariages Ã  Djerba ?',
        a: 'Oui, nous livrons et installons sur l\'île de Djerba et en Tunisie continentale.',
      },
      {
        q: 'Peut-on personnaliser les photos ?',
        a: 'Oui, maquette aux couleurs de votre mariage ou charte graphique entreprise.',
      },
      {
        q: 'Combien de photos sont incluses ?',
        a: 'Nos formules prévoient des photos illimitées pendant la durée de location choisie.',
      },
    ],
  },

  production: {
    slug: 'production',
    badge: 'Corporate Â· Clip Â· Captation',
    h1: 'Production Vidéo Corporate en Tunisie',
    intro:
      'Lbenna Prod réalise vos films corporate, captations d\'événements, clips musicaux et contenus digital Ã  Tunis et en Tunisie. De la conception au montage final, notre équipe vidéo 4K donne une image premium Ã  votre marque.',
    sections: [
      {
        title: 'Films d\'entreprise & communication interne',
        body: [
          'Nous produisons des vidéos institutionnelles : présentation de société, interviews de dirigeants, reportages sur le terrain et tutoriels. Chaque projet débute par un brief créatif et un script validé ensemble, puis tournage multi-caméras avec son direct et micro-cravate.',
          'Le montage intègre habillage graphique aux couleurs de votre charte, sous-titres FR/EN si besoin, et exports optimisés pour site web, LinkedIn et présentation salon.',
          'Nos clients corporate apprécient notre réactivité : tournage sous 48 h possible en Tunisie, livraison express pour les lancements produit.',
        ],
      },
      {
        title: 'Captation d\'événements & live streaming',
        body: [
          'Conférences, séminaires, soirées de gala, concerts : nous assurons la captation intégrale ou les highlights de vos événements. Dispositif multi-caméras, enregistrement audio professionnel, photos de couverture en parallèle si demandé.',
          'Nous pouvons également mettre en place une retransmission live streaming vers YouTube ou Facebook pour toucher une audience distante.',
        ],
      },
      {
        title: 'Clips, publicité & contenu social',
        body: [
          'Notre pôle créatif produit des clips musicaux, spots publicitaires courts et contenus verticals pour TikTok, Reels et Shorts. Nous maîtrisons la direction artistique, l\'étalonnage colorimétrique et la livraison aux formats requis par chaque plateforme.',
          'Basés Ã  Tunis avec déplacements Ã  Djerba et dans les grandes villes tunisiennes, nous adaptons les équipes (réalisateur, DOP, drone, maquillage) au budget et au calendrier du projet.',
        ],
      },
    ],
    highlights: [
      'Tournage 4K & drone',
      'Montage & étalonnage pro',
      'Sous-titres & versions multilingues',
      'Livraison rapide',
    ],
    faq: [
      {
        q: 'Quels types de vidéos corporate réalisez-vous ?',
        a: 'Films institutionnels, interviews, captation conférence, teasers produit et contenus réseaux sociaux.',
      },
      {
        q: 'Travaillez-vous avec des entreprises Ã  Djerba ?',
        a: 'Oui, nous nous déplaçons pour les hôtels, agences et événements touristiques Ã  Djerba.',
      },
      {
        q: 'Le script est-il inclus ?',
        a: 'Nous proposons l\'aide Ã  la rédaction du script et du storyboard dans nos formules corporate.',
      },
      {
        q: 'Quel est le délai de livraison ?',
        a: 'Selon la complexité : 5 Ã  15 jours ouvrés pour un montage standard, options express disponibles.',
      },
    ],
  },

  'photographe-mariage-djerba': {
    slug: 'photographe-mariage-djerba',
    badge: 'Djerba Â· Mariage destination',
    h1: 'Photographe Mariage Ã  Djerba â€” Lbenna Prod',
    intro:
      'Lbenna Prod couvre les mariages Ã  Djerba depuis 1988 : reportage photo et film vidéo dans les hôtels Hasdrubal, Radisson, riads et plages de l\'île. Notre équipe connaît Houmt Souk, Midoun, Aghir et les venues les plus demandées pour un jour J sans stress logistique.',
    sections: [
      {
        title: 'Présentation â€” votre photographe mariage Ã  Djerba',
        body: [
          'Djerba accueille chaque année des mariages tunisiens et internationaux. Nous maîtrisons la lumière forte du midi, les couchers de soleil sur la mer et les soirées en salle climatisée. Nos albums reflètent l\'authenticité de l\'île et l\'élégance de votre célébration.',
          'Nous nous déplaçons depuis Tunis avec matériel complet ou mobilisons une équipe locale selon la saison. Repérage des lieux, coordination avec le wedding planner et respect du timing religieux ou civil : chaque détail compte pour immortaliser votre union.',
        ],
      },
      {
        title: 'Déroulement du shooting mariage Ã  Djerba',
        body: [
          'La veille ou le matin du mariage, nous effectuons un briefing avec les témoins ou le planner. Couverture des préparatifs (henné, coiffure, détail de la robe), puis cérémonie et réception. Nous alternons plans posés et reportage spontané pour un album complet.',
          'Une séance couple peut être organisée le lendemain sur la plage ou dans un lieu emblématique de l\'île â€” lumière douce du matin garantie. Nous adaptons le rythme aux contraintes météo et au protocole familial.',
        ],
      },
      {
        title: 'Vidéo mariage et film cinématographique',
        body: [
          'Nos vidéastes capturent les discours, les danses et les moments forts en multi-caméras. Montage dynamique, musique sous licence, livraison en fichier HD et teaser vertical pour Instagram Reels ou TikTok.',
          'Option same-day edit pour projeter un film court pendant la soirée â€” très apprécié des mariés et invités Ã  Djerba.',
        ],
      },
      {
        title: 'Drone et vues aériennes au-dessus de Djerba',
        body: [
          'Le drone révèle la beauté des côtes djerbiennes, des jardins de réception et des cortèges en extérieur. Nous respectons la réglementation tunisienne et les autorisations hôtelières. Plans aériens intégrés au film et Ã  l\'album sur demande.',
        ],
      },
      {
        title: 'Album photo premium et galerie en ligne',
        body: [
          'Retouche professionnelle, album layflat ou coffret premium, clé USB gravée et galerie privée pour la famille Ã  l\'étranger. Livraison progressive : sélection preview sous 7 jours, album final sous 4 Ã  6 semaines selon formule.',
        ],
      },
    ],
    highlights: ['Mariages Djerba & Houmt Souk', 'Drone & album premium', 'Ã‰quipe depuis 1988', 'Devis sous 24 h'],
    faq: [
      {
        q: 'Quel est le prix d\'un photographe mariage Ã  Djerba ?',
        a: 'Les formules démarrent selon la durée de couverture et les options (vidéo, drone, album). Contactez-nous pour un devis personnalisé sous 24 h.',
      },
      {
        q: 'Travaillez-vous dans les hôtels Ã  Djerba ?',
        a: 'Oui, nous intervenons dans les hôtels, riads et salles de réception de l\'île, y compris Hasdrubal et Radisson.',
      },
      {
        q: 'Proposez-vous un photobooth ?',
        a: 'Oui, location photobooth clé en main avec animateur, photos personnalisés et galerie en ligne.',
      },
      {
        q: 'Couvrez-vous les mariages destination internationaux ?',
        a: 'Oui, nous accompagnons des couples venant de France, Belgique, Suisse et du Golfe pour un mariage Ã  Djerba.',
      },
      {
        q: 'Faut-il prévoir des frais de déplacement ?',
        a: 'La logistique Djerba est incluse dans nos devis selon la formule choisie.',
      },
    ],
  },

  'photographe-evenement-tunis': {
    slug: 'photographe-evenement-tunis',
    badge: 'Tunis Â· Ã‰vénementiel',
    h1: 'Photographe Ã‰vénementiel Ã  Tunis',
    intro:
      'Captation photo professionnelle pour galas, lancements produit, soirées corporate et cérémonies officielles Ã  Tunis et en banlieue nord. Lbenna Prod livre des images retouchées rapidement pour presse et réseaux sociaux.',
    sections: [
      {
        title: 'Ã‰vénements corporate et institutionnels',
        body: [
          'Conférences Ã  Lac 1, inaugurations Ã  La Marsa, soirées de fin d\'année en hôtel : nous adaptons notre dispositif (flash, téléobjectif, reportage discret) au protocole de votre événement.',
          'Livraison express de sélections pour LinkedIn et communiqués, plus galerie complète sous 48â€“72 h. Un chef de projet unique coordonne photo, vidéo et livrables multiformats.',
          'Nous connaissons les contraintes des salles de Tunis : accès technique, lumière mixte, timing serré entre discours et networking. Notre équipe arrive en amont pour repérage et brief avec votre communication.',
        ],
      },
      {
        title: 'Galas, soirées et lancements produit',
        body: [
          'Pour les galas et soirées privées, nous privilégions un reportage élégant : portraits VIP, ambiance salle, détails décoration et moments forts sur scène. Retouche professionnelle pour un rendu magazine.',
          'Lancements produit et inaugurations : photos packshot sur place, invités, stands et keynote. Versions carrées et verticales livrées pour Instagram, LinkedIn et communiqués presse.',
        ],
      },
      {
        title: 'Cérémonies officielles et événements publics',
        body: [
          'Nous couvrons cérémonies, forums et événements institutionnels avec discrétion et respect du protocole. Photos livrées en haute résolution pour archives et diffusion média.',
          'Options : captation vidéo en parallèle, drone si le lieu le permet, photobooth branding pour animer l\'espace invités après la partie officielle.',
        ],
      },
      {
        title: 'Zones couvertes autour de Tunis',
        body: [
          'Intervention Ã  Tunis centre, Lac 1 & 2, La Marsa, Gammarth, Ariana, Ben Arous et Sidi Bou SaÃ¯d. Déplacements en Tunisie sur devis pour Sousse, Sfax ou Djerba si votre événement le nécessite.',
        ],
      },
    ],
    highlights: [
      'Corporate Tunis & banlieue nord',
      'Livraison express 48â€“72 h',
      'Retouche & formats réseaux',
      'Photo + vidéo coordonnées',
    ],
    faq: [
      {
        q: 'Proposez-vous la couverture photo et vidéo ?',
        a: 'Oui, en package avec un chef de projet unique et livraison coordonnée.',
      },
      {
        q: 'Quel délai pour recevoir les photos après l\'événement ?',
        a: 'Une sélection express sous 48 h, galerie complète sous 48â€“72 h selon la formule.',
      },
      {
        q: 'Intervenez-vous en soirée et en faible lumière ?',
        a: 'Oui, matériel flash professionnel et sensibilité ISO maîtrisée pour salles sombres.',
      },
      {
        q: 'Peut-on personnaliser les livrables pour LinkedIn ?',
        a: 'Oui, exports optimisés carré et paysage, retouche incluse.',
      },
      {
        q: 'Comment obtenir un devis photographe événement Tunis ?',
        a: 'Contactez-nous avec date, lieu, durée et type d\'événement â€” réponse sous 24 h.',
      },
    ],
  },

  'photobooth-djerba': {
    slug: 'photobooth-djerba',
    badge: 'Djerba Â· Photobooth',
    h1: 'Location Photobooth Ã  Djerba',
    intro:
      'Animez votre mariage ou soirée Ã  Djerba avec notre photobooth Lbenna Prod : photos instantanées, fond personnalisé, animateur et galerie en ligne. Installation sur l\'île pour hôtels et venues de réception.',
    sections: [
      {
        title: 'Animation photobooth clé en main Ã  Djerba',
        body: [
          'Le photobooth crée des souvenirs tangibles pour vos invités. Nous transportons et installons la borne depuis Tunis, gérons l\'éclairage studio et personnalisons les photos aux couleurs de votre mariage ou marque.',
          'Un animateur Lbenna Prod accueille les invités, propose des accessoires et assure le bon déroulement pendant toute la réception â€” idéal après le dîner ou pendant la soirée dansante.',
        ],
      },
      {
        title: 'Mariages et réceptions sur l\'île',
        body: [
          'Hasdrubal, Radisson, riads et plages privées : nous connaissons les accès, horaires et contraintes électriques des lieux emblématiques de Djerba. Fond personnalisé aux prénoms des mariés, format polaroid ou carte postale.',
          'Combinez photobooth et reportage photo-vidéo mariage pour un package unique avec un seul interlocuteur et une logistique simplifiée.',
        ],
      },
      {
        title: 'Ã‰vénements corporate et hôtellerie',
        body: [
          'Soirées d\'entreprise, incentives et animations touristiques : branding aux couleurs de votre établissement, template logo, galerie en ligne pour partage sur les réseaux.',
          'Options GIF, boomerang vidéo, livre d\'or numérique et envoi des photos par QR code â€” parfait pour toucher une audience internationale.',
        ],
      },
      {
        title: 'Qualité d\'image et matériel pro',
        body: [
          'Ã‰clairage doux, appareil plein format et finition labo : des photos nettes même en soirée, loin des solutions low-cost. Tirages illimités pendant la durée de location choisie.',
        ],
      },
    ],
    highlights: [
      'Tirages illimités HD',
      'Installation hôtels Djerba',
      'Animateur & accessoires',
      'Galerie en ligne privée',
    ],
    faq: [
      {
        q: 'Installez-vous directement dans les hôtels de Djerba ?',
        a: 'Oui, nous connaissons les contraintes techniques des principaux établissements de l\'île.',
      },
      {
        q: 'Quelle surface faut-il prévoir sur place ?',
        a: 'Environ 3 Ã— 3 mètres pour la borne, l\'éclairage et l\'espace invités.',
      },
      {
        q: 'Peut-on personnaliser les photos mariage ?',
        a: 'Oui, maquette aux couleurs et prénoms des mariés, livrée avant l\'événement.',
      },
      {
        q: 'Le photobooth fonctionne-t-il en extérieur ?',
        a: 'Oui avec abri ou zone ombragée ; nous adaptons l\'installation Ã  la météo.',
      },
      {
        q: 'Comment réserver un photobooth Ã  Djerba ?',
        a: 'Demandez un devis en ligne avec date et lieu â€” réponse sous 24 h.',
      },
    ],
  },

  'video-corporate-tunisie': {
    slug: 'video-corporate-tunisie',
    badge: 'Corporate Â· Tunisie',
    h1: 'Production Vidéo Corporate en Tunisie',
    intro:
      'Films institutionnels, captation de séminaires et contenus digital pour entreprises tunisiennes. Lbenna Prod tourne Ã  Tunis, Sfax, Sousse et Djerba avec matériel 4K et équipe de montage intégrée.',
    sections: [
      {
        title: 'Vidéo corporate sur tout le territoire',
        body: [
          'De la rédaction du script au tournage multi-caméras et Ã  la livraison des masters, nous accompagnons PME et grands comptes. Sous-titrage FR/EN, habillage graphique aux couleurs de votre charte, exports optimisés web.',
          'Conférences, lancements produit, interviews dirigeants et teasers réseaux sociaux : un chef de projet unique coordonne tournage et post-production.',
        ],
      },
      {
        title: 'Pourquoi choisir Lbenna Prod',
        body: [
          'Studio fondé en 1988, équipe stable, matériel 4K et drone. Nous comprenons les contraintes des entreprises tunisiennes : délais serrés, validation hiérarchique, livraison multiformat.',
        ],
      },
    ],
    highlights: ['4K & drone', 'Script & storyboard', 'Sous-titres FR/EN', 'Toute la Tunisie'],
    faq: [
      { q: 'Intervenez-vous hors Tunis ?', a: 'Oui : Djerba, Sfax, Sousse et autres villes sur devis.' },
      { q: 'Quel délai de livraison pour un film corporate ?', a: '5 Ã  15 jours ouvrés selon complexité, options express disponibles.' },
      { q: 'Proposez-vous le script ?', a: 'Oui, aide Ã  la rédaction et storyboard inclus dans nos formules corporate.' },
      { q: 'Livrez-vous des versions réseaux sociaux ?', a: 'Oui, exports verticals Reels, Shorts et LinkedIn inclus sur demande.' },
      { q: 'Travaillez-vous avec des hôtels et agences Ã  Djerba ?', a: 'Oui, nous produisons régulièrement des contenus touristiques et institutionnels sur l\'île.' },
    ],
  },

  'portfolio-mariage': {
    slug: 'portfolio-mariage',
    badge: 'Portfolio Â· Mariage',
    h1: 'Portfolio Mariage â€” Reportages Photo & Vidéo',
    intro:
      'Découvrez nos reportages de mariage en Tunisie : cérémonies Ã  Tunis, réceptions Ã  Djerba, séances couple sur plage et soirées en salle. Chaque album et chaque film reflète notre exigence artistique depuis 1988.',
    sections: [
      {
        title: 'Mariages Ã  Tunis et en banlieue',
        body: [
          'Salles des fêtes, hôtels de La Marsa, villas Ã  Gammarth : nous capturons l\'émotion des mariages tunisiens et binationaux avec sensibilité et discrétion.',
        ],
      },
      {
        title: 'Mariages destination Ã  Djerba',
        body: [
          'Hôtels de luxe, plages au coucher du soleil, décors orientaux : notre portfolio Djerba montre la diversité des célébrations sur l\'île. Voir aussi notre page photographe mariage Djerba.',
        ],
      },
    ],
    highlights: ['Reportage photo & film', 'Tunis & Djerba', 'Album premium', 'Teaser réseaux sociaux'],
    faq: [
      { q: 'Puis-je voir des exemples de mariages similaires au mien ?', a: 'Contactez-nous avec votre type de lieu et nous enverrons une sélection ciblée.' },
      { q: 'Les photos du portfolio sont-elles retouchées ?', a: 'Oui, retouche professionnelle incluse dans toutes nos prestations.' },
    ],
  },

  'portfolio-photobooth': {
    slug: 'portfolio-photobooth',
    badge: 'Portfolio Â· Photobooth',
    h1: 'Portfolio Photobooth â€” Animations & Tirages',
    intro:
      'Retour en images sur nos animations photobooth : mariages, galas corporate et soirées privées Ã  Tunis et Djerba. Fonds personnalisés, photos instantanées et galerie en ligne.',
    sections: [
      {
        title: 'Photobooth mariage',
        body: [
          'Borne premium, accessoires fun, photos aux couleurs du wedding : nos invités repartent avec un souvenir tangible.',
        ],
      },
    ],
    highlights: ['Tirages illimités', 'Fond personnalisé', 'Animateur pro', 'Galerie en ligne'],
    faq: [
      { q: 'Le photobooth convient-il aux petites salles ?', a: 'Oui, nous adaptons l\'encombrement au lieu de réception.' },
    ],
  },

  'portfolio-corporate': {
    slug: 'portfolio-corporate',
    badge: 'Portfolio Â· Corporate',
    h1: 'Portfolio Corporate â€” Films & Ã‰vénements',
    intro:
      'Films institutionnels, captation de séminaires, lancements produit et contenus digital pour entreprises tunisiennes. Lbenna Prod intervient Ã  Tunis, Sfax et Djerba.',
    sections: [
      {
        title: 'Production vidéo entreprise',
        body: [
          'Interviews, motion design, captation conférence : découvrez nos réalisations corporate et demandez un devis sur mesure.',
        ],
      },
    ],
    highlights: ['4K multi-caméras', 'Montage & étalonnage', 'Sous-titres FR/EN', 'Livraison rapide'],
    faq: [
      { q: 'Signez-vous des accords de confidentialité ?', a: 'Oui, NDA possible pour les projets sensibles.' },
    ],
  },

  'portfolio-shooting': {
    slug: 'portfolio-shooting',
    badge: 'Portfolio Â· Studio',
    h1: 'Portfolio Shooting â€” Studio & Packshot',
    intro:
      'Portraits professionnels, lookbooks mode, packshots produit et shootings créatifs en studio Ã  Tunis. Ã‰clairage professionnel et retouche incluse.',
    sections: [
      {
        title: 'Studio et packshot e-commerce',
        body: [
          'Fond blanc, lifestyle ou mise en scène créative : nos shootings studio servent marques, e-commerce et réseaux sociaux.',
        ],
      },
    ],
    highlights: ['Studio équipé', 'Retouche incluse', 'Packshot e-commerce', 'Portraits pro'],
    faq: [
      { q: 'Proposez-vous la location studio seule ?', a: 'Oui, avec ou sans photographe Lbenna Prod.' },
    ],
  },

  'photobooth-tunisie': {
    slug: 'photobooth-tunisie',
    badge: 'Tunisie · Animation',
    h1: 'Location Photobooth en Tunisie — Mariage & Événements',
    intro:
      'Louez un photobooth professionnel en Tunisie avec Lbenna Prod : animation clé en main pour mariages à Tunis et Djerba, soirées corporate, anniversaires et événements touristiques. Photos HD, fond personnalisé, animateur sur place et galerie en ligne — le même niveau de qualité que nos reportages photo et vidéo depuis 1988.',
    sections: [
      {
        title: 'Pourquoi choisir notre photobooth en Tunisie',
        body: [
          'Le photobooth est devenu l\'animation incontournable des mariages et événements en Tunisie. Chez Lbenna Prod, nous ne proposons pas une simple borne low-cost : notre dispositif utilise un éclairage studio, un appareil photo professionnel plein format et une qualité d\'image premium. Les photos sont nettes, bien exposées et flatteuses — même en soirée dans une salle de réception.',
          'Depuis 1988, nous accompagnons les événements les plus exigeants à Tunis et Djerba. Ajouter un photobooth à votre mariage ou gala corporate, c\'est offrir à vos invités un souvenir tangible et créer du contenu viral pour Instagram, TikTok et Facebook. Nous personnalisons chaque photo aux couleurs de votre wedding ou de votre charte graphique entreprise.',
          'Un technicien-animateur Lbenna Prod reste présent pendant toute la durée de location : installation, accueil des invités, gestion des accessoires (chapeaux, pancartes, lunettes) et démontage en fin de soirée. Vous profitez de l\'événement, nous gérons l\'animation.',
        ],
      },
      {
        title: 'Photobooth mariage à Tunis et Djerba',
        body: [
          'En mariage, le photobooth fonctionne en continu pendant la réception : les invités repartent avec un souvenir personnalisé, vous recevez un album numérique consolidé et une galerie en ligne privée. Nous connaissons les contraintes des lieux emblématiques — hôtels de Djerba, salles des fêtes à Ariana, villas à Gammarth — et adaptons l\'installation à chaque venue.',
          'Combinez photobooth et reportage photo-vidéo mariage pour un package unique avec un seul interlocuteur. La coordination logistique est simplifiée : même équipe, même sensibilité esthétique, livrables harmonisés. C\'est la formule la plus demandée par nos couples à Tunis et sur l\'île de Djerba.',
          'Options disponibles : GIF animés, boomerang vidéo, livre d\'or photo numérique, green screen avec fond personnalisé, envoi des photos par QR code et partage instantané sur les réseaux sociaux.',
        ],
      },
      {
        title: 'Photobooth corporate et événements pro',
        body: [
          'Les entreprises tunisiennes utilisent notre photobooth pour animer séminaires, inaugurations, lancements produit et soirées de fin d\'année. Nous adaptons le branding : fond aux couleurs de l\'entreprise, template avec logo et slogan, photos format carte de visite ou polaroid premium.',
          'Le photobooth corporate génère de l\'engagement sur LinkedIn et Instagram, tout en créant une ambiance conviviale après les prises de parole officielles. Nous pouvons couvrir une soirée à Tunis ou plusieurs jours pour un festival, un salon ou un événement touristique à Djerba.',
          'La location inclut transport, montage, démontage et assistance technique. Surface recommandée : environ 3 × 3 mètres pour la borne, l\'éclairage et un espace invités confortable.',
        ],
      },
      {
        title: 'Réservation et couverture nationale',
        body: [
          'Lbenna Prod intervient sur tout le territoire tunisien : Tunis et banlieue nord (Ariana, La Marsa, Lac), Djerba (Houmt Souk, Midoun, hôtels de la côte), Sousse, Sfax et Hammamet sur devis. Réservez 2 à 3 mois à l\'avance pour la haute saison mariage.',
          'Demandez un devis photobooth en précisant la date, le lieu, la durée de location et le type d\'événement. Réponse sous 24 h avec formule détaillée : photos illimitées, nombre d\'heures, options GIF/boomerang et personnalisation des maquettes.',
        ],
      },
    ],
    highlights: [
      'Animation photobooth illimitée',
      'Animateur & accessoires inclus',
      'Tunis, Djerba & toute la Tunisie',
      'Galerie en ligne privée',
    ],
    faq: [
      {
        q: 'Quelle surface faut-il pour installer le photobooth ?',
        a: 'Environ 3 × 3 mètres suffisent pour la borne, l\'éclairage et un espace invités.',
      },
      {
        q: 'Le photobooth est-il disponible à Djerba ?',
        a: 'Oui, nous livrons et installons sur l\'île de Djerba et en Tunisie continentale.',
      },
      {
        q: 'Peut-on personnaliser les photos ?',
        a: 'Oui, maquette aux couleurs de votre mariage ou charte graphique entreprise, validée avant l\'événement.',
      },
      {
        q: 'Combien de photos sont incluses ?',
        a: 'Nos formules prévoient des photos illimitées pendant la durée de location choisie.',
      },
      {
        q: 'Peut-on combiner photobooth et reportage photo mariage ?',
        a: 'Absolument. Nous proposons des packages combinés avec un seul interlocuteur Lbenna Prod.',
      },
    ],
  },
};

export function getServicePageContent(slug: string): ServicePageContent | null {
  return SERVICE_PAGES[slug] ?? null;
}

